import classNames from "classnames";
import React from "react";

import styles from "./TeamsHighlight.module.css";

interface Props {
  dir: "rtl" | "ltr";
  img: JSX.Element;
}

const TeamsHighlight: React.FC<React.PropsWithChildren<Props>> = ({ img, dir, children }) => {
  return (
    <div className={classNames(styles.highlight, { [styles.rtl]: dir === "rtl" })}>
      <div className={styles.imgContainer}>
        <div>{img}</div>
      </div>
      <div className={styles.text}>{children}</div>
    </div>
  );
};

export default TeamsHighlight;
